import React, { useContext } from 'react';
import {
  ACTIVATE_PASSWORD_SUB_TITLE,
  ACTIVATE_PASSWORD_BULLET_ONE,
  ACTIVATE_PASSWORD_BULLET_TWO,
  ACTIVATE_PASSWORD_BULLET_THREE,
  ACTIVATE_PASSWORD_BULLET_FOUR,
  ACTIVATE_EXPRESS_CHECKOUT_ACCOUNT,
  ACTIVATE_EXPRESS_CHECKOUT_PASSWORD_BULLET_TWO,
  ACTIVATE_EXPRESS_CHECKOUT_PASSWORD_BULLET_THREE,
} from '../../config/text/text';
import ThemeContext from '../../providers/ThemeProvider';

const ActivateList = ({ isExpressCheckout }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <h2 className="list-title">
        {isExpressCheckout
          ? ACTIVATE_EXPRESS_CHECKOUT_ACCOUNT
          : ACTIVATE_PASSWORD_SUB_TITLE}
      </h2>
      <ul className="list">
        <li>{ACTIVATE_PASSWORD_BULLET_ONE}</li>
        <li>
          {isExpressCheckout
            ? ACTIVATE_EXPRESS_CHECKOUT_PASSWORD_BULLET_TWO
            : ACTIVATE_PASSWORD_BULLET_TWO}
        </li>
        <li>
          {isExpressCheckout
            ? ACTIVATE_EXPRESS_CHECKOUT_PASSWORD_BULLET_THREE
            : ACTIVATE_PASSWORD_BULLET_THREE}
        </li>
        {!isExpressCheckout && <li> {ACTIVATE_PASSWORD_BULLET_FOUR}</li>}
      </ul>
      <style jsx>{`
        .list {
          padding-left: 2rem;
        }
        .list-title {
          color: ${theme.colors.primary};
          font-size: 15px;
          margin-bottom: 1rem;
          margin-left: ${isExpressCheckout ? '-10px' : '0px'};
        }
      `}</style>
    </>
  );
};

export default ActivateList;
